module.exports = __webpack_public_path__ + "img/shipstation.28086470.png";